import { render } from "./SentinelElement.vue?vue&type=template&id=f968d61c&scoped=true"
import script from "./SentinelElement.vue?vue&type=script&lang=js"
export * from "./SentinelElement.vue?vue&type=script&lang=js"

import "./SentinelElement.vue?vue&type=style&index=0&id=f968d61c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f968d61c"]])

export default __exports__